import React from 'react';
const rows = [['Choosing the theme and writing the words for every circle', 'Ten themed circles and a monthly format, ready to run'], ['Searching for words when someone cries harder than expected', 'Ready-to-say lines on every card'], ['Intake, consent and touch pieced together each time', 'One intake, one screen and the Consent Ladder'], ['Sessions that end in a rush', 'A Ground phase, an aftercare briefing and a take-home sheet'], ['Turning down workshops and retreats you have no plan for', 'Run sheets and retreat planners, minute by minute']];
export function CostOfInaction() {
  return <section className="w-full bg-sage-deep" data-id="element-75" data-mp="3dpd3nc0kiulv">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:py-20" data-id="element-76" data-mp="3dqo71aq3q0cg">
        <h2 className="text-center font-display text-[28px] text-cream sm:text-4xl" data-id="element-77" data-mp="3im3kw2o3zw8v">
          What another from-scratch week costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-sage-line" data-id="element-78" data-mp="3slm24bcmx3x8">
          <div className="grid grid-cols-2 text-center" data-id="element-79" data-mp="3sj87u4ps3vqq">
            <div className="border-r border-sage-line bg-terra-deep px-3 py-3 font-display text-base text-white sm:text-lg" data-id="element-80" data-mp="3ehhpgp3l31hm">
              From scratch
            </div>
            <div className="bg-sage px-3 py-3 font-display text-base text-cream sm:text-lg" data-id="element-81" data-mp="34hqr2cbwk2c9">
              Session Ready
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-sage-line text-[12.5px] sm:text-sm" data-id="element-82" data-mp="11a7jb25pebi">
              <div className="border-r border-sage-line px-3.5 py-3.5 text-cream/55 line-through decoration-terra/70" data-id="element-83" data-mp="3s8ed01inksht">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-medium text-cream" data-id="element-84" data-mp="3jg2lecbsyz09">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}